module.exports = __webpack_public_path__ + "img/isotipo.06b27658.png";